<template>
  <div :class="$style.root">
    <Tab v-model="activePanel" class="tab">
      <TabPanel label="全部" name="all"></TabPanel>
      <TabPanel label="待成团" name="pending"></TabPanel>
      <TabPanel label="已成团" name="complete"></TabPanel>
      <TabPanel label="已失效" name="expired"></TabPanel>
    </Tab>
    <div :class="$style.shiyongzhuangLinkContainer">
      <div :class="$style.shiyongzhuangLink" @click="viewShiyongzhuang"
        >查看我的礼品券</div
      >
    </div>
    <div :class="$style.pintuanList">
      <PinTuanItem
        :class="$style.pintuanItem"
        v-for="item in filteredItems"
        :item="item"
        :key="item.id"
        @click="handleClick"
        @action="handleAction"
      />
      <template v-if="data.isInit">
        <div
          class="u-textCenter u-marginTop10 u-marginBottom10"
          v-if="data.loading"
          >加载中...</div
        >
        <!-- <div class="u-textCenter u-marginTop10 u-marginBottom10" v-else-if="!data.hasMore"
          >没有</div
        > -->
      </template>
    </div>
    <DialogDownloadApp
      :visible.sync="showDownloadAppPop"
      :img="resource.imgDownload"
    />
    <PinTuanWxShareGuide
      :visible.sync="showWxShareGuidePop"
      :remainTime="selectItem.remainTime"
      :remainPeople="selectItem.peopleNeed - selectItem.peopleJoined"
    />
  </div>
</template>

<script>
import { isAndroid, isiOS } from "helper/env";
import { makeUrl } from "utils/url";
import Tab, { TabPanel } from "base-components/Tab";
import service from "../../service";
import PinTuanItem from "../PinTuanItem1";
import DialogDownloadApp from "../../../190506-@shared/components/DialogDownloadApp";
import PinTuanWxShareGuide from "../../../190506-@shared/components/PinTuanWxShareGuide";

export default {
  name: "JoinedList",
  props: {
    data: {
      default() {
        return {
          items: [],
        };
      },
    },
  },
  inject: ["resource"],
  components: {
    Tab,
    TabPanel,
    PinTuanItem,
    DialogDownloadApp,
    PinTuanWxShareGuide,
  },
  data() {
    return {
      activePanel: "all",

      showDownloadAppPop: false,
      showWxShareGuidePop: false,

      selectItem: {},
    };
  },
  computed: {
    filteredItems() {
      if (this.activePanel === "all") {
        return this.data.items;
      }

      return this.data.items.filter(item => {
        if (this.activePanel === "pending") {
          return item.status === this.$const.PinTaunStatus.PENDING;
        } else if (this.activePanel === "complete") {
          return item.status === this.$const.PinTaunStatus.COMPLETE;
        } else if (this.activePanel === "expired") {
          return item.status === this.$const.PinTaunStatus.EXPIRED;
        }

        return false;
      });
    },
  },
  methods: {
    viewShiyongzhuang() {
      if (isAndroid || isiOS) {
        return service.gotoUrl(this.resource.linkShiYongZhuang, {
          withEnv: false,
        });
      }

      this.showDownloadAppPop = true;
      return;
    },
    handleClick(item) {
      const url = window.location.href.split("#")[0];
      const withoutQuery = url.replace(/\?.*$/, "");
      const targetUrl = withoutQuery.replace("pin-tuan", "pin-tuan-act");
      const jumpUrl = makeUrl(targetUrl, {
        actcode: item.actCode,
        webid: item.webId,
      });
      service.gotoUrl(jumpUrl);
    },
    handleAction(item) {
      this.selectItem = item;
      if (item.isSendCoupon) {
        this.viewShiyongzhuang();
      } else {
        service.setShareData({
          title: item.ShareTitle,
          description: item.ShareDesc,
          imageUrl: item.ShareImage,
          url: item.ShareLink,
        });
        service.shareUrl(() => {
          this.showWxShareGuidePop = true;
        });
      }
    },
  },
};
</script>

<style lang="scss">
$page-width: 375;
@import "~style/tool";
.tab.Tab {
  .Tab__toggles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 999;
  }

  .Tab__toggle {
    position: relative;
    font-size: rem(14px);
    height: rem(44px);
    line-height: rem(44px);
    color: rgba(153, 153, 153, 1);
  }

  .Tab__toggle.is-active {
    color: rgba(233, 90, 89, 1);
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: rem(40px);
      height: rem(2px);
      background: rgba(233, 90, 89, 1);
      left: 50%;
      margin-left: rem(-20px);
    }
  }

  .Tab__content {
    padding-top: rem(44px);
  }

  .Tab__Panel {
    display: none;
    background-color: #fff;
  }
}
</style>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.root {
  // position: relative;
}

.shiyongzhuangLinkContainer {
  margin-top: 10px;
}

.shiyongzhuangLink {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: rgba(233, 90, 89, 1);
  width: rem(315px);
  height: reM(44px);
  line-height: rem(44px);
  background: rgba(255, 246, 244, 1);
  border-radius: rem(23px);
  border: 1px solid rgba(255, 180, 179, 1);
}

.pintuanList {
  margin-top: 10px;
}

.pintuanItem {
  margin-top: 10px;
}
</style>
